module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ordersettle"
  }, [_c('div', {
    staticClass: "main"
  }, [(_vm.is_take_out == 1 && (_vm.is_self_take_new == 1 && _vm.is_eat_in == 0)) ? _c('div', {
    staticClass: "tabBar"
  }, [_c('div', {
    class: ['fl', 'take', {
      'active': _vm.isShow
    }],
    on: {
      "click": function($event) {
        return _vm.switchStatus('take-away')
      }
    }
  }, [_c('p', [_vm._v("外卖配送")])]), _vm._v(" "), _c('div', {
    class: ['fl', 'self', {
      'active': !_vm.isShow
    }],
    on: {
      "click": function($event) {
        return _vm.switchStatus('take-self')
      }
    }
  }, [_c('p', [_vm._v("打包自提")])]), _vm._v(" "), _c('span', {
    staticClass: "triangle"
  })]) : _vm._e(), _vm._v(" "), (_vm.is_take_out == 1 && (_vm.is_self_take_new == 0 && _vm.is_eat_in == 1)) ? _c('div', {
    staticClass: "tabBar"
  }, [_c('div', {
    class: ['fl', 'take', {
      'active': _vm.isShow
    }],
    on: {
      "click": function($event) {
        return _vm.switchStatus('take-away')
      }
    }
  }, [_c('p', [_vm._v("外卖配送")])]), _vm._v(" "), _c('div', {
    class: ['fl', 'self', {
      'active': !_vm.isShow
    }],
    on: {
      "click": function($event) {
        return _vm.switchStatus('take-eat')
      }
    }
  }, [_c('p', [_vm._v("堂食")])]), _vm._v(" "), _c('span', {
    staticClass: "triangle"
  })]) : _vm._e(), _vm._v(" "), ((_vm.is_self_take_new == 1 && _vm.is_eat_in == 1) && _vm.is_take_out == 0) ? _c('div', {
    staticClass: "tabBar"
  }, [_c('div', {
    class: ['fl', 'take', {
      'active': _vm.showSelf
    }],
    on: {
      "click": function($event) {
        return _vm.switchStatus('take-self')
      }
    }
  }, [_c('p', [_vm._v("打包自提")])]), _vm._v(" "), _c('div', {
    class: ['fl', 'self', {
      'active': _vm.showEat
    }],
    on: {
      "click": function($event) {
        return _vm.switchStatus('take-eat')
      }
    }
  }, [_c('p', [_vm._v("堂食")])]), _vm._v(" "), _c('span', {
    staticClass: "triangle"
  })]) : _vm._e(), _vm._v(" "), (_vm.is_take_out == 1 && (_vm.is_self_take_new == 1 && _vm.is_eat_in == 1)) ? _c('div', {
    staticClass: "tabBar"
  }, [_c('div', {
    class: ['fl', 'take', 'newTab', {
      'active': _vm.showTake
    }],
    on: {
      "click": function($event) {
        return _vm.switchStatus('take-away')
      }
    }
  }, [_c('p', [_vm._v("外卖配送")])]), _vm._v(" "), _c('div', {
    class: ['fl', 'self', 'newTab', {
      'active': _vm.showSelf
    }],
    on: {
      "click": function($event) {
        return _vm.switchStatus('take-self')
      }
    }
  }, [_c('p', [_vm._v("打包自提")])]), _vm._v(" "), _c('div', {
    class: ['fl', 'self', 'newTab', {
      'active': _vm.showEat
    }],
    on: {
      "click": function($event) {
        return _vm.switchStatus('take-eat')
      }
    }
  }, [_c('p', [_vm._v("堂食")])])]) : _vm._e(), _vm._v(" "), (_vm.is_take_out == 1 && _vm.showTake) ? _c('div', [_c('div', {
    staticClass: "address",
    staticStyle: {
      "padding": "0.3rem 0.2rem 0 .2rem !important"
    }
  }, [(_vm.is_take_out == 1 && (_vm.is_eat_in == 0 && _vm.is_self_take_new == 0)) ? _c('div', {
    staticClass: "oneTab"
  }, [_c('span', {
    staticStyle: {
      "font-size": ".32rem",
      "color": "#333",
      "font-weight": "600"
    }
  }, [_vm._v("外卖配送")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "address-bottom"
  }, [(JSON.stringify(_vm.defaultAddress) === '{}') ? _c('div', {
    staticClass: "arrow-right",
    on: {
      "click": _vm.jumpToaddress
    }
  }, [_vm._v("\n            新增收货地址\n          ")]) : _c('div', {
    staticClass: "arrow-right",
    on: {
      "click": _vm.jumpToaddress
    }
  }, [_c('div', {
    staticClass: "big"
  }, [_vm._v(_vm._s(_vm.defaultAddress.addressee) + " " + _vm._s(_vm.defaultAddress.mp))]), _vm._v(" "), (!_vm.defaultAddress.isLimitFloor) ? _c('div', {
    staticClass: "small"
  }, [(_vm.defaultAddress.poi_address && _vm.defaultAddress.detail) ? _c('span', [_vm._v(_vm._s(_vm.defaultAddress.poi_address) + " " + _vm._s(_vm.defaultAddress.detail))]) : (_vm.defaultAddress.build_name) ? _c('span', [_vm._v("【" + _vm._s(_vm.defaultAddress.build_name) + "-" + _vm._s(_vm.defaultAddress.floor_name) + "-" + _vm._s(_vm.defaultAddress.room_name) + "】")]) : _c('span', [_vm._v(_vm._s(_vm.defaultAddress.poi_address))])]) : _c('div', [(_vm.defaultAddress.build_name) ? _c('span', [_vm._v("【" + _vm._s(_vm.defaultAddress.build_name) + "-" + _vm._s(_vm.defaultAddress.floor_name) + "-" + _vm._s(_vm.defaultAddress.room_name) + "】")]) : _c('span', [_vm._v(_vm._s(_vm.defaultAddress.poi_address) + " " + _vm._s(_vm.defaultAddress.detail))])])])])]), _vm._v(" "), _c('div', {
    class: _vm.orderPreviewInfo.isCanChooseDeliveryWay ? 'sendTime' : 'sendTime pb20 mb20',
    attrs: {
      "id": "inputPanel"
    }
  }, [_c('div', {
    staticClass: "select arrive-time arrow-right",
    on: {
      "click": _vm.toggleProp
    }
  }, [_c('span', [_vm._v("送达时间")]), _vm._v(" "), _c('div', {
    staticClass: "input-text",
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.selectDateName) + " " + _vm._s(_vm.selectTimeName) + "\n          ")])])]), _vm._v(" "), (_vm.orderPreviewInfo.isCanChooseDeliveryWay) ? _c('div', {
    staticClass: "sendTime pb20 mb20"
  }, [_c('div', {
    staticClass: "select arrive-time arrow-right",
    on: {
      "click": _vm.toggleDeliveryProp
    }
  }, [_c('span', [_vm._v("配送方式")]), _vm._v(" "), _c('div', {
    staticClass: "input-text",
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.deliveryWay || '未选择（必选）') + "\n          ")])])]) : _vm._e(), _vm._v(" "), (_vm.banners.length > 0) ? _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.banners[0].imageUrl
    },
    on: {
      "click": function($event) {
        return _vm.bannerJump(_vm.banners[0])
      }
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.is_self_take_new == 1 && _vm.showSelf) ? _c('div', {
    staticClass: "self-take"
  }, [_c('div', {
    staticClass: "address"
  }, [(_vm.is_self_take_new == 1 && (_vm.is_eat_in == 0 && _vm.is_take_out == 0)) ? _c('div', {
    staticClass: "oneTab"
  }, [_c('span', {
    staticStyle: {
      "font-size": ".32rem",
      "color": "#333",
      "font-weight": "600"
    }
  }, [_vm._v("打包自提")])]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("自提地点")]), _vm._v(" "), _c('div', {
    staticClass: "flexrow",
    staticStyle: {
      "justify-content": "space-between",
      "margin-top": "0.2rem"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.orderPreviewInfo.pickUpAddr))]), _vm._v(" "), _c('span', {
    staticClass: "check-map",
    on: {
      "click": _vm.toCheckMap
    }
  }, [_vm._v("查看")])])]), _vm._v(" "), _c('div', {
    staticClass: "sendTime mb20 selt-take-time",
    attrs: {
      "id": "inputPanel"
    }
  }, [_c('div', {
    staticClass: "border-box"
  }, [_c('div', {
    staticClass: "select arrive-time",
    on: {
      "click": _vm.toggleProp
    }
  }, [_c('span', [_vm._v("自提时间")]), _vm._v(" "), _c('div', {
    staticClass: "input-text"
  }, [_c('span', [_vm._v(_vm._s(_vm.selectDateName) + _vm._s(_vm.selectTimeName))]), _c('span', {
    staticClass: "arrow-right"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "select arrive-time",
    staticStyle: {
      "padding-left": "0.2rem"
    }
  }, [_c('span', [_vm._v("自提电话")]), _vm._v(" "), (_vm.selfTakeMp != '' && _vm.selfTakeMp != null && _vm.selfTakeMp != undefined) ? _c('div', {
    staticClass: "input-text",
    on: {
      "click": function($event) {
        return _vm.inputPhone(1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.selfTakeMp))]), _c('span', {
    staticClass: "arrow-right"
  })]) : _c('div', {
    staticClass: "input-text",
    on: {
      "click": function($event) {
        return _vm.inputPhone(1)
      }
    }
  }, [_c('span', [_vm._v("请输入手机号")]), _c('span', {
    staticClass: "arrow-right"
  })])])])]), _vm._v(" "), (_vm.orderPreviewInfo.needBuild && _vm.orderPreviewInfo.needBuild == 1) ? _c('div', {
    staticClass: "building fs-28"
  }, [_c('div', {
    staticClass: "flex-row-bc arrow-right",
    on: {
      "click": function($event) {
        return _vm.toChoseBuilding()
      }
    }
  }, [_c('div', {
    staticClass: "color-gray"
  }, [_vm._v("宿舍信息")]), _vm._v(" "), (_vm.showChoseBuilding) ? _c('div', {
    staticStyle: {
      "margin-right": ".25rem",
      "color": "#787878"
    }
  }, [_vm._v("未选择（必选）")]) : _c('div', {
    staticStyle: {
      "margin-right": ".25rem",
      "color": "#787878"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.buildInfo[0].name) + "-" + _vm._s(_vm.buildInfo[1].name) + "-" + _vm._s(_vm.buildInfo[2].name) + "\n          ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "protocol"
  }, [_c('span', {
    class: ['icon-agree', {
      'select': _vm.isSelect
    }],
    on: {
      "click": _vm.isAgreeProtocol
    }
  }), _vm._v("同意"), _c('span', {
    on: {
      "click": _vm.toCheckProtocol
    }
  }, [_vm._v("《打包自提服务协议》")])])]) : _vm._e(), _vm._v(" "), (_vm.is_eat_in == 1 && _vm.showEat) ? _c('div', {
    staticClass: "eatBox self-take"
  }, [(_vm.is_eat_in == 1 && (_vm.is_self_take_new == 0 && _vm.is_take_out == 0)) ? _c('div', {
    staticClass: "oneTab"
  }, [_c('span', {
    staticStyle: {
      "font-size": ".32rem",
      "color": "#333",
      "font-weight": "600"
    }
  }, [_vm._v("堂食")])]) : _vm._e(), _vm._v(" "), (_vm.orderPreviewInfo.dineInShopTips) ? _c('div', {
    staticStyle: {
      "font-size": ".32rem",
      "color": "#4a4a4a"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.orderPreviewInfo.dineInShopTips) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.orderPreviewInfo.dineInTips) ? _c('div', {
    staticClass: "tips-eat"
  }, [_vm._v(_vm._s(_vm.orderPreviewInfo.dineInTips))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sendTime mb20 selt-take-time",
    attrs: {
      "id": "inputPanel"
    }
  }, [_c('div', {
    staticClass: "border-box",
    staticStyle: {
      "display": "flex",
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "select arrive-time",
    on: {
      "click": _vm.toggleProp
    }
  }, [_c('span', [_vm._v("就餐时间")]), _vm._v(" "), _c('div', {
    staticClass: "input-text"
  }, [_c('span', [_vm._v(_vm._s(_vm.selectDateName) + _vm._s(_vm.selectTimeName))]), _c('span', {
    staticClass: "arrow-right"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "select arrive-time",
    staticStyle: {
      "padding-left": "0.2rem"
    }
  }, [_c('span', [_vm._v("预留电话")]), _vm._v(" "), (_vm.selfTakeMp != '' && _vm.selfTakeMp != null && _vm.selfTakeMp != undefined) ? _c('div', {
    staticClass: "input-text",
    on: {
      "click": function($event) {
        return _vm.inputPhone(2)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.selfTakeMp))]), _c('span', {
    staticClass: "arrow-right"
  })]) : _c('div', {
    staticClass: "input-text",
    on: {
      "click": function($event) {
        return _vm.inputPhone(2)
      }
    }
  }, [_c('span', [_vm._v("请输入手机号")]), _c('span', {
    staticClass: "arrow-right"
  })])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('h3', {
    staticClass: "shop-name ellipse"
  }, [_vm._v(_vm._s(_vm.orderPreviewInfo.supplier_short_name))]), _vm._v(" "), _c('ul', {
    staticClass: "order-goods-list"
  }, _vm._l((_vm.orderPreviewInfo.right_goods), function(item) {
    return _c('li', {
      staticClass: "flexrow"
    }, [_c('div', {
      staticClass: "flexrow",
      staticStyle: {
        "width": "70%"
      }
    }, [_c('div', {
      staticClass: "goods-img",
      style: ({
        backgroundImage: 'url(' + item.thumbnail + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "goods-name-box flexcol",
      staticStyle: {
        "justify-content": "space-between"
      }
    }, [_c('span', {
      staticClass: "goods-name ellipse"
    }, [_vm._v(_vm._s(item.good_name))]), _vm._v(" "), (item.specAttrStr) ? _c('span', {
      staticClass: "goods-spec ellipse"
    }, [_vm._v(_vm._s(item.specAttrStr))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("x" + _vm._s(item.number))])])]), _vm._v(" "), _c('div', {
      staticClass: "flexrow",
      staticStyle: {
        "width": "30%",
        "justify-content": "flex-end",
        "align-items": "center"
      }
    }, [(item.ori_price) ? _c('span', {
      staticClass: "ori_price"
    }, [_vm._v("￥" + _vm._s(item.ori_price))]) : _vm._e(), _c('span', [_vm._v("￥" + _vm._s(item.price))])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "line",
    staticStyle: {
      "margin": ".2rem 0"
    }
  }), _vm._v(" "), _vm._l((_vm.orderPreviewInfo.extraFeeList), function(item) {
    return _c('div', {
      staticClass: "flex-row-bc"
    }, [_c('div', {
      style: ({
        color: item.titleColor
      }),
      on: {
        "click": function($event) {
          return _vm.viewPackDesc()
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.title) + "\n          "), (item.subTitle) ? _c('span', {
      staticStyle: {
        "font-size": ".2rem",
        "margin-left": ".1rem",
        "color": "#999"
      }
    }, [_vm._v(_vm._s(item.subTitle))]) : _vm._e(), _vm._v(" "), (item.jumpType == 500088) ? _c('span', {
      staticClass: "icon-desc"
    }, [_vm._v("?")]) : _vm._e()]), _vm._v(" "), _c('span', {
      style: ({
        color: item.valueColor
      })
    }, [_vm._v(_vm._s(item.value))])])
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#fff",
      "padding": "0.2rem 0.2rem 0",
      "margin-bottom": "0.2rem"
    }
  }, [_vm._l((_vm.orderPreviewInfo.orderFeeList), function(item) {
    return _c('div', {
      staticStyle: {
        "padding-bottom": ".2rem",
        "overflow": "hidden"
      }
    }, [_c('div', {
      staticClass: "flex-row-bc",
      style: ({
        color: item.titleColor
      })
    }, [_c('div', [_c('div', {
      staticClass: "flex-row-sc",
      on: {
        "click": function($event) {
          return _vm.showOrderFeeDesc(item)
        }
      }
    }, [_vm._v("\n              " + _vm._s(item.title) + "\n              "), (item.isShowDesc && item.isShowDesc == 1) ? _c('img', {
      staticStyle: {
        "display": "inline-block",
        "width": ".26rem"
      },
      attrs: {
        "src": require("../assets/images/icon-shuoming@2x.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (item.showDesc) ? _c('span', {
      staticStyle: {
        "font-size": ".18rem",
        "padding": ".02rem .1rem",
        "border-radius": ".12rem",
        "background-color": "#ddd"
      }
    }, [_vm._v(_vm._s(item.desc))]) : _vm._e()]), _vm._v(" "), (item.subTitle) ? _c('span', {
      staticStyle: {
        "font-size": ".2rem",
        "margin-left": ".1rem",
        "color": "#999"
      }
    }, [_vm._v("\n              " + _vm._s(item.subTitle) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', [(item.originValue) ? _c('span', {
      staticStyle: {
        "text-decoration": "line-through",
        "color": "#999"
      }
    }, [_vm._v("\n              " + _vm._s(item.originValue) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "ml10",
      style: ({
        color: item.valueColor
      })
    }, [_vm._v(_vm._s(item.value))])])]), _vm._v(" "), (item.isShowDirectDesc == 1) ? _c('div', {
      staticClass: "fs-20 mt10",
      staticStyle: {
        "color": "#999"
      }
    }, [_vm._v(_vm._s(item.directDesc))]) : _vm._e()])
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), (_vm.orderPreviewInfo.reductionAmount && _vm.orderPreviewInfo.reductionAmount > 0) ? _c('div', {
    staticClass: "activity reduction"
  }, [_vm._v("满减优惠\n        "), _c('span', {
    staticClass: "fr",
    staticStyle: {
      "color": "#F2596C"
    }
  }, [_vm._v("-￥" + _vm._s(_vm.orderPreviewInfo.reductionAmount))])]) : _vm._e(), _vm._v(" "), (_vm.giftList.length == 1) ? _c('div', [_c('div', {
    staticClass: "activity special-goods arrow-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.orderPreviewInfo.gift_activity_name))]), _vm._v(" "), (_vm.defaultGift.good_name.length < 10) ? _c('span', {
    staticClass: "fr red"
  }, [_vm._v(_vm._s(_vm.defaultGift.good_name) + "x" + _vm._s(_vm.defaultGift.number))]) : _c('span', {
    staticClass: "fr red"
  }, [_vm._v(_vm._s(_vm.defaultGift.good_name.substring(0, 10)) + "...x" + _vm._s(_vm.defaultGift.number))])])]) : _vm._e(), _vm._v(" "), (_vm.giftList.length > 1) ? _c('div', {
    staticStyle: {
      "padding-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "activity special-goods arrow-right",
    class: {
      'open': _vm.showMoreGift
    },
    on: {
      "click": _vm.selectGift
    }
  }, [_c('div', {
    staticClass: "more"
  }, [_c('span', [_vm._v(_vm._s(_vm.orderPreviewInfo.gift_activity_name))]), _vm._v(" "), (_vm.defaultGift.good_name.length < 10) ? _c('span', {
    staticClass: "fr red"
  }, [_vm._v(_vm._s(_vm.defaultGift.good_name) + "x" + _vm._s(_vm.defaultGift.number))]) : _c('span', {
    staticClass: "fr red"
  }, [_vm._v(_vm._s(_vm.defaultGift.good_name.substring(0, 10)) + "...x" + _vm._s(_vm.defaultGift.number))])])])]) : _vm._e(), _vm._v(" "), (_vm.orderType == 0 && (_vm.orderPreviewInfo.deliveryFeeCoupons || _vm.orderPreviewInfo.unValidDeliveryFeeCoupons)) ? _c('div', {
    staticClass: "flex-row-bc arrow-right activity",
    on: {
      "click": function($event) {
        return _vm.toSelectCoupon(2)
      }
    }
  }, [_c('span', [_vm._v("配送券")]), _vm._v(" "), (JSON.stringify(_vm.defaultAddress) === '{}' && _vm.orderType == 0) ? _c('div', {
    staticStyle: {
      "color": "#9B9B9B"
    }
  }, [_vm._v("请添加收货地址")]) : _c('div', [(_vm.orderPreviewInfo.deliveryFeeCoupons && _vm.orderPreviewInfo.canUseDeliveryFeeCouponNum > 0) ? _c('div', {
    staticClass: "red"
  }, [(_vm.orderPreviewInfo.deliveryFeeCouponId) ? _c('span', [_vm._v("- ￥" + _vm._s(_vm.orderPreviewInfo.deliveryFeeCouponAmount))]) : _c('div', [_vm._v("\n              " + _vm._s(_vm.orderPreviewInfo.canUseDeliveryFeeCouponNum) + "张可用\n              "), (_vm.orderPreviewInfo.maxDeliveryFeeCouponAmount) ? _c('span', [_vm._v("，最高可减" + _vm._s(_vm.orderPreviewInfo.maxDeliveryFeeCouponAmount) + "元")]) : _vm._e()])]) : _c('span', {
    staticStyle: {
      "color": "#9B9B9B"
    }
  }, [_vm._v("无可用")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-row-bc arrow-right activity",
    on: {
      "click": function($event) {
        return _vm.toSelectCoupon(1)
      }
    }
  }, [_c('span', [_vm._v("优惠券")]), _vm._v(" "), (JSON.stringify(_vm.defaultAddress) === '{}' && _vm.orderType == 0) ? _c('div', {
    staticStyle: {
      "color": "#9B9B9B"
    }
  }, [_vm._v("请添加收货地址")]) : _c('div', [(_vm.couponsList.length && _vm.orderPreviewInfo.canUseCouponNum > 0) ? _c('div', {
    staticClass: "red"
  }, [(_vm.couponInfo && _vm.couponInfo.amount) ? _c('span', [_vm._v("- ￥" + _vm._s(_vm.orderPreviewInfo.couponAmount))]) : _c('div', [_vm._v("\n              " + _vm._s(_vm.orderPreviewInfo.canUseCouponNum) + "张可用\n              "), (_vm.orderPreviewInfo.maxCouponAmount) ? _c('span', [_vm._v("，最高可减" + _vm._s(_vm.orderPreviewInfo.maxCouponAmount) + "元")]) : _vm._e()])]) : _c('span', {
    staticStyle: {
      "color": "#9B9B9B"
    }
  }, [_vm._v("无可用")])])]), _vm._v(" "), _c('div', {
    staticClass: "activity",
    staticStyle: {
      "padding-right": "0",
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "flexrow",
    staticStyle: {
      "justify-content": "flex-end"
    }
  }, [_vm._v("\n          小计"), _c('span', {
    staticStyle: {
      "font-size": "0.32rem",
      "color": "#333"
    }
  }, [_vm._v("￥" + _vm._s(_vm.orderPreviewInfo.phaseSubtotal))])])]), _vm._v(" "), (_vm.orderPreviewInfo.gift_code == '-2') ? _c('div', {
    staticClass: "notice",
    staticStyle: {
      "color": "#9b9b9b",
      "padding": "0.2rem 0",
      "border-top": "1px solid #f6f6f6"
    }
  }, [_vm._v("\n        温馨提示：赠品已经全部送完啦～\n      ")]) : _vm._e()], 2), _vm._v(" "), (_vm.orderPreviewInfo.punctualArrive) ? _c('div', {
    staticClass: "card marginB20"
  }, [_c('div', {
    staticClass: "flex-row-bc fs-28 fw-bold"
  }, [_c('div', {
    staticClass: "flex-row-bc",
    style: ({
      color: _vm.orderPreviewInfo.punctualArrive.titleColor
    })
  }, [_vm._v("\n          " + _vm._s(_vm.orderPreviewInfo.punctualArrive.title) + "\n          "), _c('img', {
    staticClass: "ml10",
    staticStyle: {
      "width": ".5rem"
    },
    attrs: {
      "src": _vm.orderPreviewInfo.punctualArrive.imgUrl
    }
  })]), _vm._v(" "), (_vm.orderPreviewInfo.punctualArrive.changeAimed) ? _c('div', {
    staticClass: "flex-row-bc",
    style: ({
      color: _vm.orderPreviewInfo.punctualArrive.valueColor
    }),
    on: {
      "click": function($event) {
        return _vm.changePunctualArrive()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.orderPreviewInfo.punctualArrive.value) + "\n          "), (_vm.orderPreviewInfo.punctualArrive.aimed) ? _c('img', {
    staticClass: "ml10",
    staticStyle: {
      "width": ".28rem"
    },
    attrs: {
      "src": require("../assets/images/btn_choose@2x.png")
    }
  }) : _c('img', {
    staticClass: "ml10",
    staticStyle: {
      "width": ".28rem"
    },
    attrs: {
      "src": require("../assets/images/btn_choose_default@2x.png")
    }
  })]) : _c('div', {
    staticClass: "flex-row-bc",
    style: ({
      color: _vm.orderPreviewInfo.punctualArrive.valueColor
    })
  }, [_vm._v("\n          " + _vm._s(_vm.orderPreviewInfo.punctualArrive.value) + "\n          "), _c('img', {
    staticClass: "ml10",
    staticStyle: {
      "width": ".28rem"
    },
    attrs: {
      "src": require("../assets/images/btn_choose@2x.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "fc-999 fs-22 mt10",
    on: {
      "click": function($event) {
        return _vm.viewPunctualArrive()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.orderPreviewInfo.punctualArrive.desc) + "\n        "), _c('img', {
    staticStyle: {
      "display": "inline-block",
      "width": ".24rem",
      "vertical-align": "middle"
    },
    attrs: {
      "src": require("../assets/images/icon-warning.png")
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.orderPreviewInfo.right_hikes && _vm.orderPreviewInfo.right_hikes.length) ? _c('div', {
    staticClass: "order-info hikes",
    staticStyle: {
      "padding-bottom": "0"
    }
  }, [_c('h3', {
    staticClass: "shop-name"
  }, [_vm._v("超值换购")]), _vm._v(" "), _c('ul', {
    staticClass: "order-goods-list"
  }, _vm._l((_vm.orderPreviewInfo.right_hikes), function(item) {
    return _c('li', {
      staticClass: "flexrow"
    }, [_c('div', {
      staticClass: "flexrow",
      staticStyle: {
        "width": "70%"
      }
    }, [_c('div', {
      staticClass: "goods-img",
      style: ({
        backgroundImage: 'url(' + item.thumbnail + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "goods-name-box flexcol",
      staticStyle: {
        "justify-content": "space-between"
      }
    }, [_c('span', {
      staticClass: "goods-name ellipse"
    }, [_vm._v(_vm._s(item.good_name))]), _vm._v(" "), _c('span', [_vm._v("￥" + _vm._s(item.price))])])]), _vm._v(" "), _c('div', {
      staticClass: "flexrow",
      staticStyle: {
        "width": "30%",
        "justify-content": "flex-end",
        "align-items": "center"
      }
    }, [(item.maxNumber > 0) ? _c('div', [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.showHikes),
        expression: "!item.showHikes"
      }],
      staticClass: "add-goods-btn btn-yellow",
      on: {
        "click": function($event) {
          return _vm.changeHikes(item)
        }
      }
    }, [_vm._v("加价购")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.showHikes),
        expression: "item.showHikes"
      }],
      staticClass: "operator-box flexrow"
    }, [_c('span', {
      class: ['operatorBtn', 'minus', {
        'grey-minus': item.number == 0
      }],
      on: {
        "click": function($event) {
          return _vm.subtractGoods(item)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "operatorBtn number"
    }, [_vm._v(_vm._s(item.number))]), _vm._v(" "), _c('span', {
      class: ['operatorBtn', 'plus', {
        'grey-minus': item.number < item.maxNumber
      }],
      on: {
        "click": function($event) {
          return _vm.addRefundGoods(item)
        }
      }
    })])]) : _c('div', {
      staticClass: "add-goods-btn"
    }, [_vm._v("售罄")])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "activity",
    staticStyle: {
      "padding-right": "0",
      "border-bottom": "none",
      "border-top": "1px solid #f6f6f6"
    }
  }, [_c('div', {
    staticClass: "flexrow",
    staticStyle: {
      "justify-content": "flex-end"
    }
  }, [_vm._v("\n          小计\n          "), (_vm.orderPreviewInfo.hikeSubTotal) ? _c('span', {
    staticStyle: {
      "font-size": "0.32rem",
      "color": "#333"
    }
  }, [_vm._v("￥" + _vm._s(_vm.orderPreviewInfo.hikeSubTotal))]) : _c('span', {
    staticStyle: {
      "font-size": "0.32rem",
      "color": "#333"
    }
  }, [_vm._v("￥0")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "list list-indent order"
  }, [_c('ul', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.orderType != 0) ? _c('li', {
    staticStyle: {
      "padding": "0 0.2rem"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "0.26rem"
    }
  }, [(_vm.showRemarks) ? _c('span', {
    staticStyle: {
      "color": "#f2596c"
    }
  }, [_vm._v("*")]) : _vm._e(), _vm._v("备注")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remarks),
      expression: "remarks"
    }],
    staticStyle: {
      "width": "85%",
      "height": "1.2rem",
      "margin-top": "0.2rem",
      "border-radius": "0.1rem",
      "padding": "0.1rem",
      "font-size": "0.28rem"
    },
    attrs: {
      "maxlength": "100",
      "placeholder": _vm.placeholder1
    },
    domProps: {
      "value": (_vm.remarks)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.remarks = $event.target.value
      }, function($event) {
        return _vm.changeComment()
      }]
    }
  })]) : _vm._e()])]), _vm._v(" "), (_vm.is_take_out == 1 && _vm.showTake) ? _c('div', {
    staticClass: "remarks-box fs-28"
  }, [_c('div', {
    staticClass: "arrow-right out-remarks",
    on: {
      "click": function($event) {
        return _vm.toRemarks()
      }
    }
  }, [_c('div', {
    staticClass: "color-gray"
  }, [(_vm.showRemarks) ? _c('span', {
    staticStyle: {
      "color": "#f2596c"
    }
  }, [_vm._v("*")]) : _vm._e(), _vm._v("备注")]), _vm._v(" "), (_vm.remarks) ? _c('div', {
    staticStyle: {
      "max-width": "5.5rem",
      "margin-right": ".2rem",
      "color": "#787878",
      "white-space": "nowrap",
      "overflow": "hidden",
      "text-overflow": "ellipsis"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.remarks) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.placeholder && !_vm.remarks) ? _c('div', {
    staticStyle: {
      "max-width": "5.5rem",
      "margin-right": ".2rem",
      "color": "#787878",
      "white-space": "nowrap",
      "overflow": "hidden",
      "text-overflow": "ellipsis"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.placeholder) + "\n        ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.orderPreviewInfo.canUseCouponNum === 0 && _vm.couponPackageList && _vm.couponPackageList.length == 1) ? _c('div', {
    staticClass: "cpackage-title",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("本单可用立减"), _c('span', {
    staticStyle: {
      "color": "#FF4A61"
    }
  }, [_vm._v(_vm._s(_vm.couponPackageList[0].package_unit_price) + "元")])]) : _vm._e(), _vm._v(" "), (_vm.orderPreviewInfo.canUseCouponNum === 0 && _vm.couponPackageList && _vm.couponPackageList.length > 0) ? _c('div', {
    staticClass: "cpackage-list"
  }, _vm._l((_vm.couponPackageList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('div', {
      staticClass: "c-tit"
    }, [_vm._v(_vm._s(item.package_coupon_title))]), _vm._v(" "), _c('div', {
      staticClass: "c-price"
    }, [_c('span', [_vm._v(_vm._s(item.package_unit_price))]), _vm._v("元x"), _c('span', [_vm._v(_vm._s(item.package_unit_num))]), _vm._v("张\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "c-desc"
    }, [_vm._v(_vm._s(item.package_coupon_desc))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "3.2rem"
      }
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.package_name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.package_shop_desc))]), _vm._v(" "), _c('div', {
      staticClass: "price"
    }, [_vm._v("\n              ¥"), _c('span', [_vm._v(_vm._s(item.package_selling_price))])])])]), _vm._v(" "), _c('div', {
      staticClass: "btn-buy",
      class: item.package_status === 0 ? 'disabled' : '',
      on: {
        "click": function($event) {
          return _vm.buyCouponPackage(item)
        }
      }
    }, [_vm._v("立即购买")])])
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.orderPreviewInfo.gift_msg || _vm.orderPreviewInfo.reductionMsg) ? _c('div', {
    staticClass: "reduce_tips"
  }, [(_vm.orderPreviewInfo.gift_msg && _vm.orderPreviewInfo.gift_msg != '') ? _c('p', [_vm._v(_vm._s(_vm.orderPreviewInfo.gift_msg))]) : _vm._e(), _vm._v(" "), (_vm.orderPreviewInfo.reductionMsg && _vm.orderPreviewInfo.reductionMsg != '') ? _c('p', [_vm._v("\n      " + _vm._s(_vm.orderPreviewInfo.reductionMsg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('footer', {
    staticClass: "dark fixed flexrow"
  }, [_c('div', [((_vm.orderType == 0 || _vm.orderType == 3) && _vm.orderPreviewInfo.saveDiscount > 0) ? _c('div', {
    staticClass: "footer-cart"
  }, [_c('span', {
    staticStyle: {
      "line-height": "1rem",
      "font-size": "0.28rem",
      "color": "#333"
    }
  }, [_vm._v("已优惠 ￥" + _vm._s(_vm.orderPreviewInfo.saveDiscount))])]) : ((_vm.orderType == 0 || _vm.orderType == 3) && _vm.orderPreviewInfo.saveDiscount == 0) ? _c('div', {
    staticClass: "footer-cart"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.28rem",
      "color": "#333",
      "width": "1.7rem",
      "height": "1rem"
    }
  })]) : ((_vm.orderType == 1 || _vm.orderType == 3) && _vm.orderPreviewInfo.saveDiscount > 0) ? _c('div', {
    staticClass: "footer-cart flexcol",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.28rem",
      "color": "#333"
    }
  }, [_vm._v("节省 ￥" + _vm._s(_vm.totalSave))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.24rem",
      "color": "#787878"
    }
  }, [_vm._v("优惠" + _vm._s(_vm.orderPreviewInfo.saveDiscount) + "+配送费" + _vm._s(_vm.orderPreviewInfo.saveDeliveryFee))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flexrow"
  }, [_c('div', {
    staticClass: "footer-cart"
  }, [_c('span', {
    staticClass: "price",
    staticStyle: {
      "line-height": "1rem",
      "margin-right": "0.2rem"
    }
  }, [_vm._v("合计 "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("￥" + _vm._s(_vm.orderPreviewInfo.real_pay))])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-cart flexcol",
    staticStyle: {
      "justify-content": "center"
    }
  }, [(_vm.orderSubmitType == 2 && _vm.isCanSubmit) ? _c('a', {
    staticClass: "btn btn-main",
    on: {
      "click": _vm.createOrder
    }
  }, [_vm._v("提交订单")]) : _c('a', {
    staticClass: "btn btn-gray"
  }, [_vm._v("提交订单")])])])]), _vm._v(" "), (_vm.propShow) ? _c('div', {
    staticClass: "mask",
    on: {
      "click": _vm.toggleProp
    }
  }) : _vm._e(), _vm._v(" "), (_vm.propShow) ? _c('div', {
    staticClass: "prop-box time-list",
    attrs: {
      "id": "prop-box"
    }
  }, [_c('div', {
    staticClass: "title ac"
  }, [_vm._v(_vm._s(_vm.timeTitle))]), _vm._v(" "), (_vm.orderPreviewInfo.dineInLimitTips && _vm.orderType == 3) ? _c('div', {
    staticClass: "dineInLimitTips"
  }, [_vm._v("\n      " + _vm._s(_vm.orderPreviewInfo.dineInLimitTips) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "select-date"
  }, _vm._l((_vm.dateList), function(item) {
    return _c('li', {
      key: item.delivery_date,
      class: {
        active: item.isActive
      },
      on: {
        "click": function($event) {
          return _vm.changeDate(item.delivery_date)
        }
      }
    }, [_vm._v(_vm._s(item.delivery_date_name) + "\n      ")])
  }), 0), _vm._v(" "), _c('ul', {
    staticClass: "select-time",
    on: {
      "scroll": _vm.handleScroll
    }
  }, _vm._l((_vm.currentTimeList), function(item) {
    return _c('li', {
      class: {
        'canSelect': item.canSelected == 0
      },
      on: {
        "click": function($event) {
          item.canSelected == 0 ? null : _vm.changeTime(item.delivery_time, item.delivery_time_name, item)
        }
      }
    }, [_vm._v(_vm._s(item.delivery_time_name) + "\n      ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.deliveryPopup) ? _c('div', {
    staticClass: "mask",
    on: {
      "click": _vm.toggleDeliveryProp
    }
  }) : _vm._e(), _vm._v(" "), (_vm.deliveryPopup) ? _c('div', {
    staticClass: "prop-box delivery-list"
  }, [_c('div', {
    staticClass: "title ac"
  }, [_vm._v("请选择配送方式")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, _vm._l((_vm.orderPreviewInfo.deliveryWayList), function(item) {
    return _c('div', {
      staticClass: "item flex-row-bc",
      on: {
        "click": function($event) {
          return _vm.choseDelivery(item)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "flex-direction": "column"
      }
    }, [_c('span', {
      class: !item.isCanSelect && item.upstairsDelivery == 1 ? 'fc-999' : '',
      staticStyle: {
        "font-size": "15px"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "fc-999",
      staticStyle: {
        "font-size": "11px"
      }
    }, [_vm._v(_vm._s(item.subTitle))]), _vm._v(" "), _c('span', {
      staticClass: "fc-999",
      staticStyle: {
        "font-size": "11px"
      }
    }, [(item.upstairsDelivery == 1) ? _c('span', [_vm._v(_vm._s(item.tip))]) : _vm._e()])]), _vm._v(" "), (item.selected) ? _c('img', {
      staticStyle: {
        "width": ".36rem",
        "height": ".36rem"
      },
      attrs: {
        "src": require("../assets/images/icon_choose@2x.png")
      }
    }) : _vm._e(), _vm._v(" "), (!item.selected) ? _c('img', {
      class: !item.isCanSelect && item.upstairsDelivery == 1 ? 'opa-5' : '',
      staticStyle: {
        "width": ".36rem",
        "height": ".36rem"
      },
      attrs: {
        "src": require("../assets/images/icon_choose_default.png")
      }
    }) : _vm._e()])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMoreGift),
      expression: "showMoreGift"
    }],
    staticClass: "gift-list ",
    on: {
      "click": _vm.selectGift
    }
  }, [_c('ul', [_c('li', {
    staticClass: "title"
  }, [_vm._v("可选赠品")]), _vm._v(" "), _vm._l((_vm.giftList), function(item) {
    return _c('li', {
      staticClass: "select-item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.changeGift(item)
        }
      }
    }, [_c('span', {
      staticClass: "gift-name"
    }, [_vm._v(_vm._s(item.good_name) + "x" + _vm._s(item.number))]), _vm._v(" "), _c('span', {
      staticClass: "icon icon-select",
      class: {
        'on': item.is_selected == 1
      }
    })])
  })], 2)]), _vm._v(" "), (_vm.showBuildingPop) ? _c('div', {
    staticClass: "mask",
    on: {
      "click": function($event) {
        _vm.showBuildingPop = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showBuildingPop) ? _c('div', {
    staticClass: "prop-box"
  }, [_c('ul', {
    staticClass: "building-title"
  }, _vm._l((_vm.buildInfo), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        'checked': item.checked
      },
      on: {
        "click": function($event) {
          return _vm.changeBuildingTitle(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.name) + "\n      ")])
  }), 0), _vm._v(" "), _c('ul', {
    staticClass: "building-cnt"
  }, _vm._l((_vm.buildingList), function(item) {
    return _c('li', {
      class: {
        'checked': item.checked
      },
      on: {
        "click": function($event) {
          return _vm.changeBuilding(item)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.area) + "\n      ")])
  }), 0)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "flexrow",
    staticStyle: {
      "align-items": "center",
      "justify-content": "space-between",
      "padding": "0 0.2rem"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "0.26rem"
    }
  }, [_vm._v("支付")]), _c('span', [_vm._v("在线支付")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "line"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-5393e1cb","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/OrderSettle.vue
// module id = 440
// module chunks = 7